import React from 'react';
import PropTypes from 'prop-types';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import draftBarImg from '../../../assets/images/status_bar_draft.svg';
import underReviewBarImg from '../../../assets/images/status_bar_under_review.svg';
import liveBarImg from '../../../assets/images/status_bar_live.svg';
import matchedBarImg from '../../../assets/images/status_bar_matched.svg';
import workStartedBarImg from '../../../assets/images/status_bar_work_started.svg';
import workCompletedBarImg from '../../../assets/images/status_bar_work_completed.svg';
import openMarketplaceLiveBarImg from '../../../assets/images/open_marketplace_status_bar_live.svg';
import openMarketplaceMatchedBarImg from '../../../assets/images/open_marketplace_status_bar_matched.svg';
import openMarketplaceWorkStartedBarImg from '../../../assets/images/open_marketplace_status_bar_work_started.svg';
import openMarketplaceWorkCompletedBarImg from '../../../assets/images/open_marketplace_status_bar_work_completed.svg';
import './ProjectStatusBar.scss';
var renderBarStatus = function renderBarStatus(status, isOpenMarketplaceOrRehire) {
  if (status === 'employer_draft') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Draft");
  }
  if (status === 'employer_requested_matching') {
    if (isOpenMarketplaceOrRehire) {
      return /*#__PURE__*/React.createElement("h2", {
        className: "demibold"
      }, "Live!");
    }
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Under Review\xA0", /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "right",
      delay: {
        show: 100
      },
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "project-status-tooltip"
      }, "Clora will help you to shape your project's needs in a scoping call!")
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-info-circle"
    })));
  }
  if (status === 'clora_matching') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Sourcing\xA0", /*#__PURE__*/React.createElement(OverlayTrigger, {
      placement: "right",
      delay: {
        show: 100
      },
      overlay: /*#__PURE__*/React.createElement(Tooltip, {
        id: "project-status-tooltip"
      }, "Your project is now public in our marketplace and our life-science experts are vetting candidates for you.")
    }, /*#__PURE__*/React.createElement("i", {
      className: "fas fa-info-circle"
    })));
  }
  if (status === 'closed') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Closed");
  }
  if (status === 'clora_matched' || status === 'executed_agreement') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Matched");
  }
  if (status === 'work_started') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Work Started");
  }
  if (status === 'work_completed') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "Work Completed");
  }
  if (status === 'on_hold') {
    return /*#__PURE__*/React.createElement("h2", {
      className: "demibold"
    }, "On Hold");
  }
  return null;
};
var renderBarImage = function renderBarImage(status, isOpenMarketplaceOrRehire) {
  if (status === 'employer_draft') {
    return /*#__PURE__*/React.createElement("img", {
      src: draftBarImg,
      alt: "Draft"
    });
  }
  if (status === 'employer_requested_matching') {
    if (isOpenMarketplaceOrRehire) {
      return /*#__PURE__*/React.createElement("img", {
        src: openMarketplaceLiveBarImg,
        alt: "Sourcing"
      });
    }
    return /*#__PURE__*/React.createElement("img", {
      src: underReviewBarImg,
      alt: "Under Review"
    });
  }
  if (status === 'clora_matching') {
    return /*#__PURE__*/React.createElement("img", {
      src: liveBarImg,
      alt: "Sourcing"
    });
  }
  if (status === 'closed') {
    return null;
  }
  if (status === 'clora_matched' || status === 'executed_agreement') {
    if (isOpenMarketplaceOrRehire) {
      return /*#__PURE__*/React.createElement("img", {
        src: openMarketplaceMatchedBarImg,
        alt: "Matched"
      });
    }
    return /*#__PURE__*/React.createElement("img", {
      src: matchedBarImg,
      alt: "Matched"
    });
  }
  if (status === 'work_started') {
    if (isOpenMarketplaceOrRehire) {
      return /*#__PURE__*/React.createElement("img", {
        src: openMarketplaceWorkStartedBarImg,
        alt: "Work Started"
      });
    }
    return /*#__PURE__*/React.createElement("img", {
      src: workStartedBarImg,
      alt: "Work Started"
    });
  }
  if (status === 'work_completed') {
    if (isOpenMarketplaceOrRehire) {
      return /*#__PURE__*/React.createElement("img", {
        src: openMarketplaceWorkCompletedBarImg,
        alt: "Work Completed"
      });
    }
    return /*#__PURE__*/React.createElement("img", {
      src: workCompletedBarImg,
      alt: "Work Completed"
    });
  }
  if (status === 'on_hold') {
    return null;
  }
  return null;
};
function ProjectStatusBar(_ref) {
  var projectStatus = _ref.projectStatus,
    isOpenMarketplaceOrRehire = _ref.isOpenMarketplaceOrRehire;
  return /*#__PURE__*/React.createElement("div", {
    className: "inline-headers style-guide"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "medium-weight muted-gray-text"
  }, "Project Status:\xA0"), renderBarStatus(projectStatus, isOpenMarketplaceOrRehire), /*#__PURE__*/React.createElement("div", {
    className: "status-bar-image-container mt-3"
  }, renderBarImage(projectStatus, isOpenMarketplaceOrRehire)));
}
ProjectStatusBar.propTypes = {
  projectStatus: PropTypes.string.isRequired,
  isOpenMarketplaceOrRehire: PropTypes.bool
};
ProjectStatusBar.defaultProps = {
  isOpenMarketplaceOrRehire: false
};
export default ProjectStatusBar;